import { AxiosInstance } from "axios";
import {
  TrainingCompletionResponse,
  TrainingModuleResponse,
} from "../types/training";
import { getApiClient } from "../utils/api.utils";

export class TrainingService {
  client: AxiosInstance;

  constructor() {
    this.client = getApiClient();
  }

  getTrainingModules = async () => {
    const response = await this.client.get<TrainingModuleResponse[]>(
      "/training/training-modules/"
    );
    return response.data;
  };

  recordTrainingCompletion = async (
    learnerId: string,
    touchpointRegistrationId: string
  ): Promise<TrainingCompletionResponse> => {
    const response = await this.client.get<TrainingCompletionResponse>(
      `/training/learners/${learnerId}/touchpoint-registrations/${touchpointRegistrationId}/`
    );
    return response.data;
  };

  private async downloadFile(
    url: string,
    defaultFilename?: string
  ): Promise<Blob> {
    const response = await this.client.get(url, { responseType: "blob" });

    const contentDisposition = response.headers["content-disposition"];
    const contentType = response.headers["content-type"];
    let filename = defaultFilename;

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        filename = fileNameMatch[1];
      }
    }

    const href = window.URL.createObjectURL(
      new Blob([response.data], { type: contentType })
    );
    const anchorElement: HTMLAnchorElement = document.createElement("a");

    anchorElement.href = href;
    anchorElement.download = filename ? filename : "download";

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);

    return response.data;
  }

  downloadTouchpoint = async (touchpointId: string): Promise<Blob> => {
    return this.downloadFile(
      `/training/training-modules/${touchpointId}/download/`,
      `${touchpointId}`
    );
  };

  downloadTrainingModule = async (trainingModuleId: string): Promise<Blob> => {
    return this.downloadFile(
      `/training/training-modules/all-touchpoints/${trainingModuleId}/download/`,
      `${trainingModuleId}`
    );
  };

  downloadAsset = async (
    trainingModuleId: string,
    assetId: string
  ): Promise<Blob> => {
    return this.downloadFile(
      `/training/training-modules/${trainingModuleId}/assets/${assetId}/`
    );
  };

  downloadAllAssets = async (trainingModuleId: string): Promise<Blob> => {
    return this.downloadFile(
      `/training/training-modules/${trainingModuleId}/assets/`
    );
  };
}
